import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, showAuthInstead, onShowAuth }) => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!loading && user === null) {
      if (showAuthInstead && onShowAuth) {
        // Remember where they were headed so we can send them back after they sign in
        try { sessionStorage.setItem('postLoginRedirect', location.pathname + location.search); } catch {}
        onShowAuth();
      } else {
        navigate('/');
      }
    }
  }, [user, loading]);

  if (loading) return null;
  if (!user) return null;
  return children;
};

export default ProtectedRoute;